import authInterceptor from "../AuthInterceptor";

export const CommentsAPI = {
    addComment: (bodyData) =>
        authInterceptor.post(`ranking-api/add-comment/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    viewComment: (bodyData) =>
        authInterceptor.post(`ranking-api/list-comment/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
}